/**
 * Template scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_Template
 * @extends Scene
 */

Scene_Template = (function(Scene) {

	var Scene_Template = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Template.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function(){
			this.dontRedraw = false; // prevent to redraw scene
		},
		
		/**
		 * @inheritdoc Scene#create
		 */
		create: function() {
			return $('#scene-template');
		},
		
		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function() {
		},
		
		/**
		 * @inheritdoc Scene#render
		 */
		render: function() {
		},

		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function($el, event) {
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function($el, event) {
			if(DialogManager.hasActiveDialog()) {
				return;
			}
			if(Device.isWEBOS) {return;}
			App.exit();
		},
		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function(direction) {
		},
		
		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function() {
			if(DialogManager.hasActiveDialog()) { 
				return;
			}
			
			return innerSnip.focus() || App.navigationSnip.focus();
		},
		
		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function(fromScene) {
			this.dontRedraw = true;
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}

	});

	return Scene_Template;

})(Scene);


//////////////////
// WEBPACK FOOTER
// ./js/scene/_template.js
// module id = 52
// module chunks = 0